import { SelectionModel } from '@angular/cdk/collections';
import { Component, Inject } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/functions';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatListOption } from '@angular/material/list/selection-list';
import { User } from '../user.model';

type TravelAdvisor = { id: string, email: string, displayName: string, pendingAssignmentProposalsCount: number, pendingItinerariesCount: number, destinations: string, itinerariesCount: number, visible: boolean };

@Component({
  selector: 'app-itinerary-settings-assignment-proposals-dialog',
  templateUrl: './itinerary-settings-assignment-proposals-dialog.component.html',
  styleUrls: ['./itinerary-settings-assignment-proposals-dialog.component.css']
})
export class ItinerarySettingsAssignmentProposalsDialogComponent {

  loading = true;

  travelAdvisors: TravelAdvisor[];

  searchTerm: string;

  selectedOptions: string[]

  constructor(
    private dialogRef: MatDialogRef<ItinerarySettingsAssignmentProposalsDialogComponent>,
    private angularFireFunctions: AngularFireFunctions,
    @Inject(MAT_DIALOG_DATA) public data: { ids: string[], users: User[] }
  ) {
    this.loadData();
  }

  private async loadData() {
    const dataApi = this.angularFireFunctions.httpsCallable('dataApi');
    try {
      const result: TravelAdvisor[] = await dataApi({
        table: "travel-advisors"
      }).toPromise();

      this.travelAdvisors = [];

      this.data.users.forEach((u) => {
        const ta: TravelAdvisor = { ...u } as any as TravelAdvisor;

        const resultItem = result.find((r) => r.id === ta.id);
        if (resultItem) {
          ta.itinerariesCount = resultItem.itinerariesCount;
          ta.pendingAssignmentProposalsCount = resultItem.pendingAssignmentProposalsCount;
          ta.pendingItinerariesCount = resultItem.pendingItinerariesCount;
          ta.destinations = resultItem.destinations ? resultItem.destinations.replace(RegExp("\n\n", 'g'), "\n") : null;
        }

        ta.visible = true;

        this.travelAdvisors.push(ta);
      });

      this.loading = false;

    } catch (error) {
      // TODO: show error
      this.loading = false;
      console.error(error);
      alert(error);
    }
  }

  filter(searchTerm: string) {

    const match = (s: string) => {
      return s && s.toLowerCase().indexOf(searchTerm.trim().toLowerCase()) > -1
    }
    if (searchTerm && searchTerm.trim()) {
      this.travelAdvisors.forEach((ta) => ta.visible = match(ta.displayName) || match(ta.email) || match(ta.id) || match(ta.destinations));
    } else {
      this.travelAdvisors.forEach((ta) => ta.visible = true);
    }
    return this.travelAdvisors;
  }

  userAlreadyHasAProposal(userId: string) {
    return this.data.ids && this.data.ids.indexOf(userId) > -1;
  }

  ok() {
    this.dialogRef.close(this.selectedOptions);
  }

}
